<script setup>
import { useI18n } from "vue-i18n";
import { Icon } from "@iconify/vue";
import { computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const props = defineProps({
  data: { type: Object, required: true },
  websiteId: { type: Number, required: true },
  elementId: { type: Number, required: true },
  position: { type: String, default: "top" },
});

const { t } = useI18n();
const positionClass = computed(() => props.position);
</script>
<template>
  <div class="container">
    <div class="col-12 btn-add-element" :class="positionClass">
      <span class="btn-add-icon">
        <Icon
          icon="bi:plus-circle"
          :inline="true"
          width="48"
          height="48"
          @click="
            router.push({
              name: 'pages.element.post',
              params: {
                websiteId: props.websiteId,
                pageId: props.data.pageId,
                elementId: props.elementId,
                position: props.position,
              },
            })
          "
        />
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-add-element {
  margin-left: -20px;
  z-index: 100;
  text-align: center;
  min-height: 48px;

  &.top {
    margin-bottom: -40px;
  }
  &.down {
    margin-top: -40px;
  }

  &.block {
    margin: 15px 0 0 -15px;
  }
}

.btn-add-icon {
  background: #fff;
  border-radius: 50%;
  position: absolute;
  z-index: 500;
}

.btn-element-type {
  margin: 10px;
  display: inline-block;
}
</style>
